import { ColGroupDef, ValueFormatterParams } from '@ag-grid-community/core';

import { genericGetAttributeColumns } from '@features/budget-attributes/attribute-columns';

import { ZERO_HYPHEN } from '@shared/constants/format';
import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';

import { getCostCategoryColumn } from './ima-cost-category-column';
import {
  defaultHeaderClass,
  defaultMinWidth,
  InMonthAdjustmentGridConfigContext,
} from './ima-grid-config-context';
import { ImaTableGroups } from '../enum/ima-table-gropes';

export const imaVendorContractColumnGroup = (
  ctx: InMonthAdjustmentGridConfigContext
): ColGroupDef => {
  const attributeConfig = ctx.attributeConfig;

  const pivotColumns = genericGetAttributeColumns({
    attributeConfig,
    colDefOverrides: {
      cellClass: getCellClassForGroups,
      headerClass: defaultHeaderClass,
      minWidth: defaultMinWidth,
      pinned: 'left',
    },
    onlyPivot: true,
    showHeaderTooltip: true,
    widthConfig: {
      maxWidth: 320,
      minWidth: defaultMinWidth,
      offset: 60,
    },
  });

  return {
    children: [
      {
        cellClass: getCellClassForGroups,
        field: 'vendorName',
        headerClass: defaultHeaderClass,
        headerName: 'Vendor Contract',
        headerTooltip: 'Vendor Contract',
        minWidth: defaultMinWidth,
        pinned: 'left',
        valueFormatter: (params: ValueFormatterParams) => {
          if (params.node?.isRowPinned()) {
            return 'Total';
          }

          return params.value || ZERO_HYPHEN;
        },
        width: 250,
      },
      {
        cellClass: getCellClassForGroups,
        field: 'activity_name',
        headerClass: defaultHeaderClass,
        headerName: 'Activity',
        headerTooltip: 'Activity',
        minWidth: defaultMinWidth,
        pinned: 'left',
        tooltipField: 'activity_name',
        width: 250,
      },
      ...(pivotColumns.length ? pivotColumns : [getCostCategoryColumn(ctx)]),
    ],
    groupId: ImaTableGroups.VENDOR_CONTRACT,
    headerClass: ['text-center', 'header-marker'],
    headerName: 'Vendor Contract',
    suppressStickyLabel: true,
  };
};
